import React, { useState } from "react";
import { useTranslation } from "@helpers/translate";
import Input from "../shared/Input";
import FormButton from "../shared/FormButton";
import ArrowLeftIcon from "@components/library/Icons/ArrowLeftIcon";
import { useDispatch } from "react-redux";
import { recoverPassword } from "@actions";
import {
  getEmailStatus,
  getEmailMessage,
  isEmailValid,
} from "@utils/validation";
import "../AuthForm.sass";
import "./ForgotPasswordForm.sass";

const ForgotPasswordForm = ({ setView, isMobile = false }) => {
  const { __ } = useTranslation();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const isFormValid = () => {
    return isEmailValid(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      await dispatch(recoverPassword({ email }));
      setView("check-inbox");
    } catch (e) {
      const backendMessage =
        e?.response?.data?.message || e?.message || __("error.incorrect_email");
      setError(backendMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`auth-form${
        isMobile ? " auth-form--mobile auth-form--forgot-mobile" : ""
      }`}
    >
      <form
        className={`auth-form__form${
          isMobile ? " auth-form__form--mobile" : " auth-form__form--reset"
        }`}
        onSubmit={handleSubmit}
      >
        {/* Back button - desktop only */}
        {!isMobile && (
          <button
            type="button"
            onClick={() => setView("login")}
            className="auth-form__back-link"
          >
            <ArrowLeftIcon className="h-4 w-4" />
            <span>{__("auth.backToSignIn")}</span>
          </button>
        )}

        <h1
          className={`auth-form__title${
            isMobile ? " auth-form__title--mobile" : " auth-form__title--reset"
          }`}
        >
          {__("auth.passwordReset")}
        </h1>

        {/* Description - desktop only */}
        {!isMobile && (
          <p className="auth-form__description">
            {__("auth.passwordResetDesc")}
          </p>
        )}

        <Input
          label={__("auth.emailAddress")}
          type="email"
          message={
            getEmailMessage(email) ? __("auth.pleaseEnterValidEmail") : ""
          }
          status={getEmailStatus(email)}
          messageStatus={getEmailStatus(email)}
          value={email}
          onChange={(e) => {
            if (error) setError("");
            setEmail(e.target.value);
          }}
          className={`auth-form__input-wrapper${
            isMobile
              ? " auth-form__input-wrapper--mobile"
              : " auth-form__input-wrapper--reset"
          }`}
        />

        {error && <p className="auth-form__error">{error}</p>}

        <p
          className={`auth-form__remember-password${
            isMobile ? " auth-form__remember-password--mobile" : ""
          }`}
        >
          {isMobile
            ? __("auth.rememberedPassword")
            : __("auth.rememberPassword")}{" "}
          <button
            type="button"
            className="auth-form__remember-password-link"
            onClick={() => setView("login")}
          >
            {__("auth.logIn")}
          </button>
        </p>

        <FormButton
          variant="secondary"
          type="submit"
          className={`auth-form__button-wrapper${
            isMobile
              ? " auth-form__button-wrapper--mobile auth-form__button-wrapper--forgot-mobile"
              : " auth-form__button-wrapper--reset"
          }`}
          disabled={!isFormValid() || loading}
          isLoading={loading}
        >
          {isMobile ? __("auth.resetPasswordButton") : __("auth.resetPassword")}
        </FormButton>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;
